import React from 'react'
import styled from 'styled-components'
import TwoButtons from '../components/twoButtons'
import Footer from '../components/footer'

const EndSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20rem 0 0rem;
  & > h3 {
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
      Arial, sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: 45px;
    color: #4f4f4f;
    text-align: center;
    max-width: 600px;
    padding: 0 1rem;
    @media (max-width: 768px) {
      font-size: 25px;
      line-height: 35px;
    }
  }
`

const EndButtons = styled.div`
  display: flex;
  justify-content: center;
  margin: 3rem 0 0;
`

class EndSection extends React.Component {
  render() {
    return (
      <EndSectionContainer>
        <h3>
          Thanks for taking a look. Want to share thoughts, work with me or just
          be internet friends? <br />
          <br />
          I’d love to hear from you.
        </h3>
        <EndButtons>
          <TwoButtons />
        </EndButtons>
        <Footer />
      </EndSectionContainer>
    )
  }
}

export default EndSection
